module.exports = __webpack_public_path__ + "static/img/gd2.3d7bf65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/gd2.png
// module id = 298
// module chunks = 34